import { render, staticRenderFns } from "./QuizCreatorModal.vue?vue&type=template&id=7edcba4b&"
import script from "./QuizCreatorModal.vue?vue&type=script&lang=js&"
export * from "./QuizCreatorModal.vue?vue&type=script&lang=js&"
import style0 from "./QuizCreatorModal.vue?vue&type=style&index=0&id=7edcba4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports